import styled from "styled-components";
import { BREAKPOINT_MAX } from "../../../styles/responsiveBreakpoints";

export const Container = styled.div`
  margin: auto 0;
  min-width: 0;
`;

export const TitleContainer = styled.div`
  margin-top: 2rem;
`;

export const HeaderTitle = styled.span`
  font-size: 2.5rem;
  font-weight: bold;
  display: block;
  word-break: break-word;

  @media (max-width: ${BREAKPOINT_MAX.lg}px) {
    font-size: 2rem;
  }

  @media (max-width: ${BREAKPOINT_MAX.md}px) {
    font-size: 1.5rem;
  }
`;

export const ActionText = styled.span`
    padding-left: 0.5rem;

    &:hover {
        color: ${({ theme }) => theme.tokens.color.interaction.softHover} !important;
        text-decoration: underline;
    }
`;

export const BackButton = styled.button`
    cursor: pointer;
    color: ${({ theme }) => theme.tokens.color.interaction.softDefault};
    padding-left: 0.5rem;
    border: none;
    font-size: 1rem;
    font-weight: bold;
    font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    &:hover {
        opacity: 0.6;
    }
`;
